import styled from '@emotion/styled';
import * as React from 'react';
import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';
import { observer } from 'src/utils/mobx-react';

const setChevronPosition = (position: 'up' | 'right' | 'down' | 'left'): string => {
    if (position === 'down') {
        return 'rotate(0)';
    }

    if (position === 'left') {
        return 'rotate(90deg)';
    }

    if (position === 'right') {
        return 'rotate(-90deg)';
    }

    return 'rotate(180deg)';
};

interface SvgElementPropsType {
    position: 'up' | 'right' | 'down' | 'left';
}

const SvgElement = styled('svg', { label: 'SvgElement' })<SvgElementPropsType>`
    height: auto;
    transform: ${({ position } ): string => setChevronPosition(position)};
    transition: ${easeTransform};
`;

interface ChevronPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
    position: 'up' | 'right' | 'down' | 'left';
}

export const ChevronIconBold = observer('ChevronIconBold', ({ className, onClick, position }: ChevronPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='#1e293b'
            height='20'
            onClick={onClick}
            position={position}
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path fill='#fill' d='m6.577 7.597 3.43 3.43 3.43-3.43L14.91 9.07l-4.903 4.903L5.104 9.07l1.473-1.473Z'/>
        </SvgElement>
    );
});


